import React from 'react';
import {
    makeStyles
} from '@material-ui/core';

export const BiltyHomeCss = makeStyles((theme) => ({

    divV1: {
        display: 'flex',
        position: 'absolute',
        top: '18%',
        alignItems: 'center',
        marginLeft: 96
    },
    divV2: {
        position: 'relative'
    },
    divV3: {
        color: 'white',
        marginLeft: 24
    },
    divV4: {
        fontSize: 16,
        fontWeight: 300
    },
    divV5: {
        fontSize: 32,
        fontWeight: 500,
        marginTop: 4
    },
    divV6: {
        marginTop: 4
    },
    youtubeIcon: {
        fontSize: 54
    },
    divV7: {
        width: 307,
        borderRadius: 4,
        cursor: 'pointer'
    },
    divV8: {
        width: 307,
        borderRadius: 4,
        marginLeft: 56,
        cursor: 'pointer'
    },
    divV9: {
        backgroundColor: '#e5446d',
        color: 'white',
        fontSize: 18,
        paddingTop: 12,
        paddingBottom: 12,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        textAlign: 'center'
    },
    divV10: {
        backgroundColor: '#00875a',
        color: 'white',
        fontSize: 18,
        paddingTop: 12,
        paddingBottom: 12,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        textAlign: 'center'
    },
    divContainer: {
        paddingTop: 28,
        marginBottom: 6,
        display: 'flex',
        justifyContent: 'center',
    },
    divV11: {
        border: '4px solid #d8dbe4',
        height: 474,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'auto'
    },
    divV12: {
        border: '4px solid #d8dbe4',
        height: 474,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'auto'
    },
    iconV1: {
        fontSize: 64
    },
    divV13: {
        '& .no-js': {
            width: 304,
            height: 427
        }
    },
    divStep: {
        color: '#2c5de5',
        fontSize: 12,
        fontWeight: 500
    },
    divStepName: {
        fontWeight: 'bold',
        marginTop: 6
    },
    divDetails: {
        marginTop: 4,
        opacity: 0.5,
        fontSize: 12
    },
    divDetails1: {
        opacity: 0.5,
        fontSize: 12
    },
    simTrackingIcon: {
        width: 420,
        height: 202
    },
    gridV1: {
        marginTop: 22,
        paddingLeft: 24,
        paddingRight: 24
    },
    notesIcon: {
        fontSize: 70
    },
    floppyIcon: {
        fontSize: 70
    },
    floppyDiskIcon: {
        fontSize: 70
    },
    privacyApprovalIcon: {
        fontSize: 70
    },
    mtV1: {
        marginTop: 24
    },
    divContent: {
        marginLeft: 16
    },
    divTerms: {
        backgroundColor: '#f1f1f3',
        paddingLeft: 39,
        paddingRight: 39,
        paddingTop: 20,
        paddingBottom: 20,
        fontSize: 12,
        textAlign: 'center',
        marginTop: 20
    },
    aV1: {
        color: 'black',
        fontWeight: 'bold',
        '&:hover': {
            color: 'black',
            textDecoration: 'none !important'
        }
    },
    divLock: {
        marginTop: 12,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    lockIcon: {
        color: '#00875a',
        fontSize: 24,
        marginRight: 8
    },
    iconV2: {
        color: 'grey',
        marginRight: 8,
        marginLeft: 8,
        fontSize: 6
    }
}));

export const BiltyCompanyDetailsCss = makeStyles((theme) => ({

    divPhoto: {
        border: '3px solid #e4e4e4',
        borderRadius: 16,
        width: 96,
        height: 96,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    divV1: {
        color: 'grey',
        fontSize: 12,
        marginTop: 2
    },
    divV2: {
        backgroundColor: '#f1f1f3',
        padding: 24,
        borderRadius: 8
    },
    divTitle: {
        color: 'grey',
        fontSize: 12,
        marginBottom: 2
    },
    cameraIcon: {
        color: 'grey',
        fontSize: 24
    },
    divV3: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    divWatermark: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    divContainer: {
        paddingLeft: 38,
        paddingRight: 38,
        paddingTop: 24
    },
    editIcon: {
        color: '#0033cc',
        fontSize: 13
    },
    editButton: {
        borderRadius: '8px !important',
        backgroundColor: 'white',
        padding: 8,
        '&:hover': {
            backgroundColor: 'white'
        }
    },
    switchTrack: {
        height: '10px',
        width: 20,
        marginTop: -1,
    },
    switchThumb: {
        width: 12,
        height: 13,
    },
    switchChecked: {
        color: '#0033cc !important',
        border: 'none !important'
    },
    switch: {
        marginTop: 7,
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#0033cc'
        },
        '& .MuiSwitch-thumb': {
            boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 2px rgb(0 0 0 / 14%), 0px 0px 3px 3px rgb(0 0 0 / 12%)"
        }
    },
    fwBold: {
        fontWeight: 'bold'
    },
    divGst: {
        color: '#0033cc',
        fontWeight: 'bold'
    },
    divV4: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    mtV1: {
        marginTop: 12
    },
    divRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 12
    },
    divV5: {
        marginLeft: 7
    },
    divEnd: {
        textAlign: 'end'
    },
    imgV1: {
        width: 96,
        height: 96,
        borderRadius: 8,
        border: '1px solid lightgrey'
    }

}));

export const BiltyConsignorConsigneeCss = makeStyles((theme) => ({

    textV1: {
        marginTop: 8,
        "& .MuiInputBase-input": {
            paddingTop: '8.5px',
            paddingBottom: '8.5px'
        }
    },
    divGst: {
        color: '#0033cc',
        fontWeight: 'bold'
    },
    divTitle: {
        color: '#6b778c',
        fontSize: 12
    },
    mtV1: {
        marginTop: 16
    },
    divTitleV1: {
        fontSize: 11,
        color: '#6b778c',
        textTransform: 'uppercase',
        letterSpacing: '0.05em'
    },
    divContainer: {
        backgroundColor: '#f1f1f3',
        borderRadius: 8,
        height: 112,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 8
    },
    divContainerError: {
        backgroundColor: '#f1f1f3',
        borderRadius: 8,
        height: 112,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 8,
        border: '1px solid #ff1744'
    },
    addButton: {
        backgroundColor: 'white',
        color: '#0033cc',
        textTransform: 'capitalize',
        borderRadius: 8,
        fontWeight: 'bold',
        paddingLeft: 17,
        paddingRight: 17,
        paddingTop: 7,
        paddingBottom: 7,
        '&:hover': {
            backgroundColor: 'white'
        }
    },
    addIcon: {
        fontSize: 17,
        marginRight: 8
    },
    mtV2: {
        marginTop: 24
    },
    divContainerV1: {
        backgroundColor: '#f1f1f3',
        borderRadius: 8,
        padding: 24,
        marginTop: 8
    },
    divContainerV2: {
        padding: 24
    },
    divV1: {
        display: 'flex',
        // alignItems: 'center',
        justifyContent: 'space-between'
    },
    changeButton: {
        backgroundColor: 'white',
        color: '#0033cc',
        fontWeight: 'bold',
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 16,
        paddingRight: 16,
        borderRadius: 8,
        textTransform: 'capitalize',
        fontSize: 12,
        '&:hover': {
            backgroundColor: 'white'
        }
    },
    divTitleV2: {
        fontSize: 12,
        color: 'rgba(11, 19, 35, 0.6)'
    },
    divV2: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: 12
    },
    mtV3: {
        marginTop: 12
    },
    divError: {
        color: '#ff1744',
        fontSize: 12,
        marginTop: 2
    },
    divEnd: {
        textAlign: 'end'
    }
}));

export const BiltyLoadAndTripDetailsCss = makeStyles((theme) => ({
    alignEnd: {
        textAlign: 'end'
    },
    textV1: {
        marginTop: 8,
        "& .MuiInputBase-input": {
            paddingTop: '8.5px',
            paddingBottom: '8.5px'
        }
    },
    divV1: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 16
    },
    widthV1: {
        width: '48%'
    },
    divTitleV1: {
        fontSize: 12,
        color: '#6b778c',
    },
    mtV1: {
        marginTop: 16
    },
    listBoxAutoCompelete: {
        margin: 0,
        padding: 0
    },
    listBoxOption: {
        padding: 0,
        minHeight: 46,
        maxHeight: 46,
        borderBottom: '1px solid #eaedf3',
        "&:first-child": {
        },
        "&:last-child": {
        }
    },
    divTitleV2: {
        color: '#6d717b',
        fontSize: 12
    },
    divAlignV1: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    divAlignV2: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 16
    },
    divValue: {
        fontWeight: 'bold',
        marginTop: 2
    },
    textV2: {
        color: '#6d717b'
    },
    divAlignV3: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 2
    },
    divTitleV3: {
        color: '#1a1a1a',
        fontSize: 12
    },
    divChargesContainer: {
        backgroundColor: '#f1f1f3',
        borderRadius: 4,
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        marginTop: 16
    },
    textV3: {
        fontWeight: 'bold',
        fontSize: 16
    },
    gridV2: {
        width: '43%'
    },
    divFlex: {
        display: 'flex', alignItems: 'center', overflowWrap: 'break-word'
    },
    divWidth: {
        maxWidth: '80%'
    },
    startDate: {
        fontSize: 12,
        letterSpacing: '0.03em',
        marginTop: 4,
        opacity: 0.8,
        minWidth: '6.2em'
    },
    endDate: {
        fontSize: 12,
        letterSpacing: '0.03em',
        marginTop: 4,
        opacity: 0.8
    },
    dividerV1: {
        borderBottom: '1px solid white', width: '45%', marginRight: -2, marginLeft: 8, minWidth: 15
    },
    fsV1: {
        fontSize: 28
    },
    dividerV2: {
        borderBottom: '1px solid white', width: '100%', marginLeft: -2, marginRight: 8, minWidth: 15
    },
    gridV1: {
        textAlign: 'end',
        width: '43%'
    },
    divHeader: {
        backgroundColor: '#161f34',
        color: 'white',
        padding: 16,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8
    },
    divMainContainer: {
        backgroundColor: '#f1f1f3',
        paddingRight: 24,
        paddingLeft: 24,
        paddingBottom: 24,
        paddingTop: 24
    },
    divSubContainner: {
        borderRadius: 8,
    },
    divContent: {
        backgroundColor: 'white',
        padding: 16,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8
    },
    gridV3: {
        marginTop: 8
    },
    divText: {
        color: '#6b778c',
        textTransform: 'uppercase',
        fontSize: 11,
        fontWeight: 'bold',
        marginBottom: 8
    },
    divContentV1: {
        padding: 24,
        paddingBottom: 0
    },
    divLoad: {
        fontWeight: 'bold'
    },
    mtV2: {
        marginTop: 12
    },
    mtV3: {
        marginTop: 8
    },
    labelV1: {
        '& .MuiTypography-root': {
            fontSize: '14px !important'
        },
        '& .Mui-checked': {
            color: '#6200ee',
        }
    },
    divAlignV4: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        paddingLeft: 10,
        paddingRight: 10,
    },
    addIcon: {
        fontSize: 18,
        color: '#0033cc'
    },
    divV2: {
        display: 'flex'
    },
    divV3: {
        color: '#0033cc',
        display: 'flex'
    },
    cherveRightIcon: {
        color: '#0033cc',
        fontSize: 20
    },
    divListItem: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 14,
        paddingRight: 14
    },
    textFieldV2: {
        "& .MuiInputBase-input": {
            textTransform: 'capitalize'
        }
    },
    autoCompleteV1: {
        paddingBottom: '4px !important',
        paddingTop: '4px !important'
    },
    divError: {
        color: '#ff1744',
        fontSize: 12,
        marginTop: 2
    }
}));

export const BiltyInsuranceSignatureCss = makeStyles((theme) => ({

    buttonV1: {
        backgroundColor: 'white',
        color: '#0033cc',
        borderRadius: '1px solid #F8F8F8',
        textTransform: 'capitalize',
        borderRadius: 8,
        fontSize: 12,
        paddingTop: 7,
        paddingBottom: 7,
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: 'white'
        }
    },
    divContainer: {
        backgroundColor: 'white',
        height: 112,
        width: 372,
        borderRadius: 8,
        marginTop: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold'
    },
    divContainerV1: {
        backgroundColor: '#f1f1f3',
        padding: 24
    },
    addIcon: {
        color: '#0033cc',
        fontSize: '16px !important'
    },
    divV1: {
        color: '#6b778c',
        fontSize: 12,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        fontWeight: 'bold'
    },
    divContent: {
        paddingTop: 24,
        paddingLeft: 24,
        paddingRight: 24,
        paddingBottom: 24
    },
    divTitle: {
        fontWeight: 'bold'
    },
    textFieldV1: {
        marginTop: 6,
        "& .MuiInputBase-input": {
            paddingTop: '8.5px',
            paddingBottom: '8.5px'
        }
    },
    divTitleV1: {
        fontSize: 12,
        color: 'rgba(11, 19, 35, 0.6)'
    },
    mtV1: {
        marginTop: 16
    },
    mtV2: {
        marginTop: 8
    },
    editButton: {
        color: '#0033cc',
        fontWeight: 500,
        fontSize: 12
    },
    divDisplay: {
        backgroundColor: 'white',
        borderRadius: 8,
        height: 80,
        padding: 16,
        marginTop: 8,
        width: '100%',
        overflow: 'auto'
    },
    divAlign: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    uploadButton: {
        backgroundColor: 'white',
        color: '#0033cc',
        borderRadius: '1px solid #F8F8F8',
        textTransform: 'capitalize',
        borderRadius: 8,
        fontSize: 12,
        paddingTop: 7,
        paddingBottom: 7,
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: 'white'
        }
    },
    divDisplayV1: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 112,
        borderRadius: 8,
        backgroundColor: 'white',
        marginTop: 8,
        padding: 16
    },
    divInsuranceCard: {
        padding: 16,
        borderRadius: 8,
        backgroundColor: 'white',
        marginTop: 8
    },
    divProvider: {
        fontSize: 12,
        color: '#0b1323'
    },
    providerText: {
        fontSize: 16,
        fontWeight: 'bold',
        marginTop: 4
    },
    divV2: {
        marginLeft: 9
    },
    editIcon: {
        color: '#0033cc',
        fontSize: 16
    },
    editButtonV1: {
        border: '1px solid lightgrey',
        borderRadius: 8,
        backgroundColor: 'white',
        width: 32,
        height: 32
    },
    dividerV1: {
        borderTop: '3px dashed #E8E8E8'
    },
    divTitleV2: {
        color: '#656565',
        fontSize: 12,
        fontWeight: 500
    },
    divValue: {
        fontSize: 12,
        color: '#656565'
    },
    divAlignV1: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 8
    },
    divAlignV3: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    divAlignV2: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    divV3: {
        display: 'flex',
        alignItems: 'center'
    },
    emptyIcon: {
        fontSize: 42,
        marginTop: 2
    },
    divDes: {
        marginTop: 8,
        opacity: 0.5,
        fontSize: 12
    },
    imgV1: {
        width: 90,
        height: 90,
        flexGrow: 1
    },
    buttonV2: {
        backgroundColor: 'white',
        color: '#5170f0',
        borderRadius: 8,
        fontSize: 12,
        fontWeight: 'bold',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: 'white'
        }
    },
    divV4: {
        display: 'flex'
    },
    switchTrack: {
        height: '10px',
        width: 20,
        marginTop: -1,
    },
    switchThumb: {
        width: 12,
        height: 13,
    },
    switchChecked: {
        color: '#0033cc !important',
        border: 'none !important'
    },
    switch: {
        marginTop: 7,
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#0033cc'
        },
        '& .MuiSwitch-thumb': {
            boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 2px rgb(0 0 0 / 14%), 0px 0px 3px 3px rgb(0 0 0 / 12%)"
        }
    },
    divDisplayV2: {
        backgroundColor: 'white',
        padding: 16,
        borderRadius: 8,
        marginTop: 8
    },
    divV5: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginRight: -12
    },
    divChangeButton: {
        marginLeft: 8
    }
}));

export const BiltyTimelineCss = makeStyles((theme) => ({

    divContainer: {
        padding: 24,
        paddingBottom: 0
    },
    buttonv1: {
        border: '1px solid #0033cc',
        color: '#0033cc',
        borderRadius: 8,
        paddingTop: 9,
        paddingBottom: 9,
        paddingLeft: 12,
        paddingRight: 12,
        fontWeight: 500,
        fontSize: 12,
        textTransform: 'capitalize',
    },
    divTitle: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    divSubText: {
        opacity: 0.5,
        marginTop: 4
    },
    mtV1: {
        marginTop: 16
    },
    buttonV2: {
        backgroundColor: '#0033cc',
        color: 'white',
        borderRadius: 8,
        fontWeight: 500,
        paddingTop: 9,
        paddingBottom: 9,
        paddingLeft: 16,
        paddingRight: 16,
        fontSize: 12,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#0033cc'
        }
    },
    divTitlev1: {
        fontWeight: 'bold',
        color: 'white'
    },
    divSubTextV1: {
        marginTop: 4,
        color: 'white',
        opacity: 0.76,
        fontSize: 10
    },
    divSubTextV2: {
        marginTop: 2,
        color: 'white',
        opacity: 0.76,
        fontSize: 10
    },
    divSubTextV3: {
        fontSize: 12,
        color: 'white',
        marginTop: 4
    },
    divContainerV1: {
        backgroundImage: 'linear-gradient(to top, #2c5de5, #2b4dda)',
        borderRadius: 8,
        padding: 16,
        display: 'flex'
    },
    billIcon: {
        width: 84,
        height: 80
    },
    mlV1: {
        marginLeft: 16
    },
    timeLineItem: {

        '&:before': {
            padding: '0px !important',
            flex: 0,
            content: 'none !important'
        }
    },
    editIcon: {
        fontSize: 13,
        marginRight: 10
    },
    dotV1: {
        width: 20,
        height: 21,
        padding: '0px !important',
        color: 'white',
        backgroundColor: '#0033cc',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 12,
        fontWeight: 300
    },
    timeLineRootV1: {
        paddingLeft: 14,
        paddingRight: 14
    },
    mtV2: {
        marginTop: 32
    },
    dotV2: {
        backgroundColor: '#00875a',
        color: 'white',
        width: 20,
        height: 21,
        padding: '0px !important',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 14
    },
    doneIcon: {
        fontSize: 17
    },
    divV5: {
        paddingBottom: 34
    }
}));